<template>
  <div class="row">
    <div class="col">
      <h5>Dashboard - {{ currentTypeName }}</h5>
    </div>
  </div>
  <div class="row">
    <div v-if="isAdmin" class="col-3">
      <Multiselect
        ref="searchLocation"
        v-model="foundLocation"
        class="form-control custom-multiselect"
        placeholder="type to search for a location"
        :close-on-select="true"
        :filter-results="false"
        :min-chars="1"
        :resolve-on-load="false"
        :delay="500"
        :searchable="true"
        :open-direction="'bottom'"
        :options="
          async (query) => {
            return await fetchLocations(query)
          }
        "
        label="name"
        value-prop="id"
        @select="selectedLocation"
        @clear="clearSelection"
      />
    </div>
    <div class="col-6">
      <div class="input-group">
        <input v-model="dateStart" type="date" name="dateStart" class="form-control" @change="fetchTransactions" />
        <input v-model="dateEnd" type="date" name="dateEnd" class="form-control" @change="fetchTransactions" />
        <select v-model="currentType" title="review by" class="form-control custom-types" @change="fetchTransactions">
          <option v-for="item of dashboardTypes" :key="item.value" :value="item.value">{{ item.name }}</option>
        </select>
        <span class="input-group-text custom-clear" @click="clearFilter"><i class="fas fa-times"></i></span>
        <button v-if="currentType === 'invoiceTransactions'" class="btn btn-primary custom-space" @click="download">Download</button>
        <button v-if="currentType === 'invoiceTransactions'" class="btn btn-primary" @click="previewPDF">Preview</button>
      </div>
    </div>
    <div v-if="currentType === 'invoiceTransactions'" class="col text-right">
      <span># records: {{ transactions?.length }}</span>
    </div>
  </div>
  <hr />
  <div class="row">
    <div class="col">
      <div v-show="currentType === 'totalcount'">
        <span class="custom-title">Total Transactions:</span>
        <span>{{ totalCounts }}</span>
      </div>
      <div v-show="currentType === 'totals'">
        <!-- <div v-show="currentType === 'totals'"> -->
        <TotalsChart v-if="transactions?.length" :transactions="transactions" />
      </div>
      <div v-show="currentType === 'totalcountOverTime'">
        <TotalsChartOverTime v-if="transactions?.length" :transactions="transactions" />
      </div>
      <div v-show="currentType === 'totalsByVendor'">
        <VendorsTotalsChart v-if="transactions?.length" :transactions="transactions" />
      </div>
      <div v-show="currentType === 'totalsByVendorOverTime'">
        <VendorsTotalsTimeChart v-if="transactions?.length" :transactions="transactions" />
      </div>
      <div v-show="currentType === 'invoiceTransactions'">
        <TransactionListing v-if="transactions?.length" ref="transactionListing" :transactions="transactions" />
      </div>
      <div v-show="currentType === 'invoices'">
        <LocationInvoices ref="invoices" />
      </div>
    </div>
  </div>
  <DialogPreview v-model="actionPreview" @closing="closeModal" />
</template>
<script>
import { mapState, mapActions } from 'pinia'
import { authStore } from '@/stores/auth'
import { dashboardStore } from '@/stores/dashboard'
import { locationStore } from '@/stores/location'
import Multiselect from '@vueform/multiselect'
import TotalsChart from '@/components/dashboard/charts/TotalsChart.vue'
import TotalsChartOverTime from '@/components/dashboard/charts/TotalsChartOverTime.vue'
import VendorsTotalsChart from '@/components/dashboard/charts/VendorsTotalChart.vue'
import VendorsTotalsTimeChart from '@/components/dashboard/charts/VendorsTotalTimeChart.vue'
import TransactionListing from './TransactionListing.vue'
import DialogPreview from '@/components/locations/forms/DialogPreview.vue'
import LocationInvoices from '@/components/locations/forms/LocationInvoices.vue'
export default {
  name: 'DashboardTransactions',
  components: {
    Multiselect,
    TotalsChart,
    TotalsChartOverTime,
    VendorsTotalsChart,
    VendorsTotalsTimeChart,
    TransactionListing,
    LocationInvoices,
    DialogPreview
  },
  mounted() {
    this.resetLocation()
    this.clearFilter()
  },
  data() {
    return {
      chartOptions: null,
      foundLocation: null,
      isLoadingReport: false,
      actionPreview: null
    }
  },
  computed: {
    ...mapState(authStore, ['profile']),
    ...mapState(dashboardStore, ['filterParams', 'reviewTypes', 'transactions']),
    ...mapState(locationStore, ['location', 'foundLocations']),
    isAdmin() {
      let _is = false
      if ([1].includes(this.profile.roles[0])) {
        _is = true
      }
      return _is
    },
    isShop() {
      let _is = false
      if ([13, 14].includes(this.profile.roles[0])) {
        _is = true
      }
      return _is
    },
    dashboardTypes() {
      let _types = []
      if (this.reviewTypes) {
        if (!this.isShop) {
          _types = this.reviewTypes.filter((x) => x.value !== 'invoices')
        } else {
          _types = this.reviewTypes
        }
      }
      return _types
    },
    totalCounts() {
      let _total = 0
      if (this.transactions) {
        _total = this.transactions
      }
      return _total
    },
    currentTypeName() {
      let _type = null
      if (this.reviewTypes) {
        let found = this.reviewTypes.find((x) => x.value === this.currentType)
        if (found) {
          _type = found.name
        }
      }
      return _type
    },
    currentType: {
      get() {
        let _type = null
        if (this.filterParams) {
          _type = this.filterParams.type
        }
        return _type
      },
      set(value) {
        this.setFilter({
          name: 'type',
          value: value
        })
      }
    },
    dateStart: {
      get() {
        let _date = null
        if (this.filterParams) {
          _date = this.filterParams.startdate
        }
        return _date
      },
      set(value) {
        this.setFilter({
          name: 'startdate',
          value: value
        })
      }
    },
    dateEnd: {
      get() {
        let _date = null
        if (this.filterParams) {
          _date = this.filterParams.enddate
        }
        return _date
      },
      set(value) {
        this.setFilter({
          name: 'enddate',
          value: value
        })
      }
    }
  },
  methods: {
    ...mapActions(dashboardStore, ['resetTransactions', 'getTransactions', 'resetFilter', 'setFilter', 'getTransactionReport']),
    ...mapActions(locationStore, ['searchLocations', 'resetLocation', 'getLocation']),
    closeModal() {
      this.actionPreview = null
    },
    async fetchLocations(query) {
      let search = {
        search: query,
        type: 99,
        firm: this.profile.firm
      }
      let results = await this.searchLocations(search)
      return results
    },
    clearSelection() {
      this.setFilter({
        name: 'firm',
        value: this.profile.firm
      })
      this.fetchTransactions()
    },
    selectedLocation() {
      console.log('Selected Location', this.foundLocation)
      this.$nextTick(() => {
        let found = this.foundLocations.find((x) => parseInt(x.id) === parseInt(this.foundLocation))
        if (found) {
          this.setFilter({
            name: 'firm',
            value: found.id
          })
          this.fetchTransactions()
        }
      })
    },
    clearFilter() {
      this.resetFilter()
      this.resetTransactions()
      this.setFilter({
        name: 'firm',
        value: this.profile.firm
      })
      this.setFilter({
        name: 'type',
        value: 'totalcount'
      })
    },
    async fetchTransactions() {
      if (this.currentType === 'invoices' && this.isShop) {
        console.log('Fetching Invoices', this.location)
        if (this.location === null) {
          await this.getLocation(this.profile.firm)
        } else if (this.location.firm === null) {
          await this.getLocation(this.profile.firm)
        }
        await this.$refs.invoices.getInvoices()
        return
      }
      this.resetTransactions()
      await this.getTransactions(this.filterParams)
    },
    download() {
      if (this.$refs.transactionListing) {
        this.$refs.transactionListing.download()
      }
    },
    async previewPDF() {
      if (!this.isLoadingReport) {
        this.actionPreview = null
        this.isLoadingReport = true
        console.log('Preview Transactions Report', this.filterParams)
        let report = null
        try {
          report = await this.getTransactionReport(this.filterParams)
        } catch (error) {
          console.error('previewPDF:', error)
          alert('No transactions found for the selected date range')
        }
        if (report) {
          console.log('Report', report)
          if (report.error) {
            alert('Failed to fetch PDF')
          } else {
            const content = `data:application/pdf;base64,${report.pdf}`
            this.actionPreview = {
              title: 'Invoice Transactions',
              content: content,
              mimeType: 'application/pdf',
              height: '550px',
              size: 'modal-lg'
            }
          }
        }
        this.isLoadingReport = false
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-types {
  width: 120px;
}
.custom-clear {
  cursor: pointer;
}
.custom-title {
  font-weight: 500;
  margin-right: 10px;
}
.custom-space {
  margin-right: 2px;
}
</style>
